export function updateViewBox(data) {
    const node = data.svg && data.svg._node;
      if (node) {
          node.setAttribute(
              'viewBox',
              `0 0 ${node.clientWidth} ${node.clientHeight}`
          );
      }
  }
  